module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter TableOfContents"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  })]), _c('div', {
    staticClass: "title-block"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_c('h1', [_c('i', [_vm._v("Contents")])])])]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }), _c('div', {
    staticClass: "block list-toc"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_c('i')]), _c('i', [_c('a', {
    attrs: {
      "href": "#/a9781847674562_introduction#rw-title-block_107227-00001"
    }
  }, [_vm._v("Introduction")])])]), _c('p', [_c('a', {
    attrs: {
      "href": "#/a9781847674562_prologue#rw-title-block_107228-00001"
    }
  }, [_c('i', [_vm._v("Prologue")]), _vm._v(": A Foreign Office Romance")])]), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "href": "#/a9781847674562_part_01#rw-title-block_107252-00001"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("THE EXPLOITS OF BRIGADIER GERARD")]), _vm._v(":")])]), _c('p', [_c('a', {
    attrs: {
      "href": "#/a9781847674562_chapter_01#rw-title-block_107230-00001"
    }
  }, [_vm._v("The Medal of Brigadier Gerard")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_02#rw-title-block_107231-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Brigadier Held the King")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_03#rw-title-block_107232-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the King Held the Brigadier")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_04#rw-title-block_107233-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Brigadier Slew the Brothers of Ajaccio")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_05#rw-title-block_107234-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Brigadier Came to the Castle of Gloom")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_06#rw-title-block_107235-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Brigadier Took the Field Against the Marshal Millefleurs")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_07#rw-title-block_107236-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Brigadier was Tempted by the Devil")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_08#rw-title-block_107237-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Brigadier Played for a Kingdom")])]), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847674562_part_02#rw-title-block_107238-00001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("THE ADVENTURES OF GERARD")]), _vm._v(":")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_09#rw-title-block_107239-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crime of the Brigadier")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_10#rw-title-block_107240-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Brigadier Gerard Lost his Ear")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_11#rw-title-block_107241-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Brigadier Saved the Army")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_12#rw-title-block_107242-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Brigadier Rode to Minsk")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_13#rw-title-block_107243-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brigadier Gerard at Waterloo")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_13#rw-h2_107243-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  I. The Adventure of the Forest Inn")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_14#rw-h2_107244-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" II. The Adventure of the Nine Prussian Horsemen")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_15#rw-title-block_107245-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Brigadier in England")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_16#rw-title-block_107246-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Brigadier Joined the Hussars of Conflans")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_chapter_17#rw-title-block_107247-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Etienne Gerard said Good-bye to his Master")])]), _c('p', [_c('span', {
    attrs: {
      "href": "#/a9781847674562_epilogue#rw-title-block_107248-00001",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epilogue")]), _vm._v(": The Marriage of the Brigadier")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c6393c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/a9781847674562_tableofcontents.vue
// module id = 63
// module chunks = 0